import { LoggingService } from '@instinet-analytics/core-lib';
import IndigoServiceClient from 'communication/IndigoServiceClient';
import { buildLogger, Logger } from '@instinet-analytics/core-lib';
import { ApiRequestOptions } from 'communication/ApiCallInfo';
import IndigoApiError from 'communication/IndigoApiError';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';
import { TradeDatesResponse } from 'tradeDates/api/TradeDatesResponse.ts';

export interface TradeDatesApiOptions {
    loggingService: LoggingService;
    indigoServiceClient: IndigoServiceClient;
}

export class TradeDatesApi {
    private indigoServiceClient: IndigoServiceClient;
    private logger: Logger;

    public constructor(options: TradeDatesApiOptions) {
        this.indigoServiceClient = options.indigoServiceClient;
        this.logger = buildLogger('IndigoApi', options.loggingService);
    }

    public async getTradingDays(
        symbol: string,
        symbology: SymbologyValues,
        ndays: number,
        options: ApiRequestOptions
    ): Promise<TradeDatesResponse> {
        const queryParameters = {
            symbol,
            symbology,
            ndays: ndays.toString(),
        };
        const url = 'symbol/tradeDates';

        return await IndigoApiError.runHandlingErrorsAsync(
            `Get Symbol Trading Days`,
            async () => {
                return await this.indigoServiceClient.get<TradeDatesResponse>(
                    url,
                    options,
                    queryParameters
                );
            }
        );
    }
}
